import { IRootState } from '..'

export const getProgram = (state: IRootState, id: string) =>
  state.programState.programs.filter(program => program.id === id)[0]
